import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Typography } from '@material-ui/core';
import SelectInput from '../select';
import { useStyles } from './styles';

interface Filters {
  name: string;
  value: string | number;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  options: any[];
}

interface DropdownFiltersProps {
  filters: Filters[];
}

const DropdownFilters = ({ filters }: DropdownFiltersProps) => {
  const { t } = useTranslation();
  const classes = useStyles();
  return (
    <>
      <Typography variant="body1" className={classes.filtersLabel}>
        {t('v2.dashboard.section_eventList_label_filters')}
      </Typography>

      <Box className={classes.filterWrapper}>
        {filters.map(({ name, value, onChange, options }: any) => (
          <Box key={name}>
            <SelectInput value={value} onChange={onChange} options={options} />
          </Box>
        ))}
      </Box>
    </>
  );
};

export default DropdownFilters;
